/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Discount announcement bar
const initDiscountAnnouncement = () => {
    const section = document.querySelector('#discount-announcement')
    const announcementBar = document.querySelector('#announcement-bar')

    if (section) {
        const code = localStorage.getItem('applied-discount-for-announcement')

        if (code) {
            const value = window.discount_announcement.find((el) =>
                el.code.toLowerCase() === code.toLowerCase()
            ).value

            if (value) {
                section.querySelector('[data-discount-value]').textContent = `${value}% off`
                section.querySelector('[data-discount-code]').textContent = code

                section.style.display = 'block'

                if (announcementBar) {
                    announcementBar.style.display = 'none'
                }
            }
        }
    }
}
initDiscountAnnouncement()

// Offcanvas mobile menu - Adjust top position
document.querySelector('#offcanvas-mobile-menu').addEventListener('show.bs.offcanvas', (e) => {
    const topDistance = document.querySelector('#navbar').getBoundingClientRect().bottom
    e.target.style.top = `${topDistance}px`
    document.documentElement.classList.add('offcanvas-mobile-menu-fix-backdrop')

    setTimeout(() => {
        document.documentElement.classList.remove('offcanvas-mobile-menu-fix-backdrop')
        document.querySelector('.offcanvas-backdrop').style.top = `${topDistance}px`
    }, 100)
})

// Offcanvas mobile menu - Adjust menu/close icon on the navbar
document.querySelector('#offcanvas-mobile-menu').addEventListener('show.bs.offcanvas', (e) => {
    document.querySelector('#navbar a[href="#offcanvas-mobile-menu"]').classList.add('open')
})

document.querySelector('#offcanvas-mobile-menu').addEventListener('hide.bs.offcanvas', (e) => {
    document.querySelector('#navbar a[href="#offcanvas-mobile-menu"]').classList.remove('open')
});

// Offcanvas mobile menu - init Mmenu Light
(() => {
    const menu = new MmenuLight(document.querySelector('#offcanvas-mobile-menu-nav'))
    menu.navigation({
        title: 'Shop'
    })
})()

// Carousel - Go to corresponding slide on editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

// Parallax with text
const initParallaxWithText = () => {
    document.querySelectorAll('.parallax-with-text.jarallax:not(.init)').forEach(($el) => {
        $el.classList.add('init')

        jarallax($el, {
            speed: Number($el.dataset.parallaxSpeed)
        })
    })
}
initParallaxWithText()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.parallax-with-text.jarallax')) {
        initParallaxWithText()
    }
})

/*
    Product Sticky ATC  - Handle Visibility
*/
const productStickyATCVisibility = () => {
    const $stickyATC = document.querySelector('#product-sticky-atc')

    if ($stickyATC) {
        const $atcForm = document.querySelector('#product-page form[action="/cart/add"]')
        const threshold = $atcForm.getBoundingClientRect().bottom
        const $htmlEl = document.documentElement
        const stickyATCheight = $stickyATC.clientHeight

        window.addEventListener('scroll', () => {
            if (window.scrollY > threshold) {
                $stickyATC.classList.add('show')
                $htmlEl.style.paddingBottom = `${stickyATCheight}px`
                const gorgiasEl = document.querySelector('#gorgias-chat-container')
                if (gorgiasEl) {
                    gorgiasEl.style.display = 'none'
                }
            } else {
                $stickyATC.classList.remove('show')
                $htmlEl.style.paddingBottom = 0
                const gorgiasEl = document.querySelector('#gorgias-chat-container')
                if (gorgiasEl) {
                    gorgiasEl.style.display = 'block'
                }
            }
        })
    }
}
productStickyATCVisibility()

/*
    Product Sticky ATC  - Handle variant change
*/
const productStickyATCVariantChange = () => {
    const $variantSelecetor = document.querySelector('#product-sticky-atc select[name="id"]')

    $variantSelecetor?.addEventListener('change', (e) => {
        const variantImage = $variantSelecetor.options[$variantSelecetor.selectedIndex].dataset.variantImg

        if (variantImage) {
            const $img = $variantSelecetor.closest('#product-sticky-atc').querySelector('.product-img')
            $img.setAttribute('src', variantImage)
        }
    })
}
productStickyATCVariantChange()

/*
    Recommended Products
*/
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('.recommended-products')
    if (recommendedProducts) {
        const {
            sectionId, baseUrl, productId, limit
        } = recommendedProducts.dataset

        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`

        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data

                const $smartShypItem = document.querySelector('.recommended-products [data-is-smartshyp="true"]')

                if ($smartShypItem) {
                    $smartShypItem.remove()
                } else {
                    document.querySelector('.recommended-products [data-is-smartshyp]').remove()
                }
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})
